import { Component, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterLink } from "@angular/router";
import { CheckboxComponent } from "@components/checkbox/checkbox.component";
import { IconButtonComponent } from "@components/icon-button/icon-button.component";
import { IconComponent } from "@components/icon/icon.component";
import { ListColumnDirective } from "@components/list/list-column.directive";
import { ListComponent } from "@components/list/list.component";
import { ActivityStatus } from "~app/common/models/constants";
import { AnvandareService } from "~app/common/services/anvandare.service";
import { EventService } from "~app/common/services/cqs/event.service";
import { ActivityViewModel } from "./ActivityViewModel";

@Component({
    selector: "rask-start-aktiviteter",
    templateUrl: "./aktiviteter.component.html",
    styleUrls: ["./aktiviteter.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CheckboxComponent,
        FormsModule,
        ListComponent,
        ListColumnDirective,
        RouterLink,
        IconComponent,
        IconButtonComponent
    ]
})

export class AktiviteterComponent implements OnInit {
    aktiviteter: ActivityViewModel[];
    filteredAktiviteter: ActivityViewModel[];
    visaActive = true;
    visaError = true;
    visaOk = false;

    private readonly anvandareService = inject(AnvandareService);
    private readonly eventService = inject(EventService);

    dismissActivity(id: number) {
        this.anvandareService.dismissActivities([id]);
    }

    filterChanged() {
        this.filteredAktiviteter = this.aktiviteter.filter(x => ((!this.visaError && x.status !==  ActivityStatus.Fel) || this.visaError) &&
                                                                ((!this.visaActive && x.status !==  ActivityStatus.Pagaende) || this.visaActive) &&
                                                                ((!this.visaOk && x.status !==  ActivityStatus.Ok) || this.visaOk));
    }

    getStatusIcon(status: string) {
        return this.anvandareService.getActivityStatusIcon(status);
    }

    ngOnInit(): void {
        this.eventService.subscribeAllArbetsorderSaga()
            .subscribe(() => {
                this.anvandareService.getAktivitetshistorik();
            });
        this.anvandareService.aktiviteter$.subscribe(res => {
            this.aktiviteter = res.activities.map(x => new ActivityViewModel(x));
            this.filterChanged();
        });
    }

    showDismiss(row: ActivityViewModel): boolean {
        return row.status === ActivityStatus.Fel;
    }
}
